import * as types from '../types/menuCount';
import * as actions from '../actions/menuCount';

const initState: types.MenuCountState = {
  menuCount: [],
};

export default function(
  state: types.MenuCountState = initState,
  action: actions.MenuCountActions,
): types.MenuCountState {
  switch (action.type) {
    case actions.GET_MENU_COUNT_CUCCESS: {
      const newMenuCount = [...state.menuCount];
      (action.data || []).forEach((item) => {
        const index = newMenuCount.findIndex((i) => i.key === item.key);

        if (~index) {
          newMenuCount.splice(index, 1, item);
        } else {
          newMenuCount.push(item);
        }
      });

      return { ...state, menuCount: newMenuCount };
    }
  }
  return state;
}
